export default __webpack_public_path__ + "static/media/cub.6034cee9.jpg";